/**
 * KHIYARSA (Phase 2): main-menu entries for the cloud layer. Rendered from
 * AppMainMenu (marked patch there).
 */
import { MainMenu } from "@excalidraw/excalidraw/index";
import {
  loginIcon,
  LoadIcon,
  save,
} from "@excalidraw/excalidraw/components/icons";
import React from "react";

import { useAtomValue, useSetAtom } from "../../app-jotai";

import { cloudDialogAtom, cloudUserAtom } from "./atoms";
import { cloudSync } from "./sync";
import { useCloudT } from "./strings";

export const KhiyarsaCloudMenuItems = () => {
  const t = useCloudT();
  const user = useAtomValue(cloudUserAtom);
  const setDialog = useSetAtom(cloudDialogAtom);

  if (user === undefined) {
    // auth state not resolved yet — render nothing rather than flicker
    return null;
  }

  if (!user) {
    return (
      <MainMenu.Item
        icon={loginIcon}
        onSelect={() => setDialog({ type: "auth" })}
      >
        {t("signIn")}
      </MainMenu.Item>
    );
  }

  return (
    <>
      <MainMenu.Item
        icon={LoadIcon}
        onSelect={() => setDialog({ type: "projects" })}
      >
        {t("myProjects")}
      </MainMenu.Item>
      <MainMenu.Item
        icon={save}
        onSelect={() => setDialog({ type: "saveAs" })}
      >
        {t("saveToCloud")}
      </MainMenu.Item>
      <MainMenu.Item
        icon={loginIcon}
        onSelect={() => {
          cloudSync.signOut();
        }}
      >
        {t("signOut")}
      </MainMenu.Item>
    </>
  );
};
